import React from 'react';
import { Alert } from 'reactstrap';

import { ROLLBACK_POINTS } from '~support-at-home/forms/statements/rollbackWarnings';

// TAV-3491: mirrors the New Statement Introduction, so the rollback reads as the same serious process
const Introduction: React.FC = () => {
  return (
    <div className="p-3">
      <h5 className="mb-3">Welcome to the Support at Home Statement Rollback</h5>

      <p className="mb-3">
        <strong>A rollback permanently removes every statement for the month and clients in this link.</strong>
        <br />
        It is only for statements that were generated in error.
      </p>

      <p className="mb-3">
        <strong>Before you continue:</strong>
      </p>
      <ul className="mb-3" data-cy="statements-rollback-points">
        {ROLLBACK_POINTS.map(({ point }) => (
          <li key={point}>{point}</li>
        ))}
      </ul>

      <p className="mb-3">
        You will be asked to confirm these points, then type ROLL BACK, before anything is changed.
      </p>

      <Alert color="danger" className="mb-3">
        <strong>DO NOT PROCEED</strong> unless TurnPoint Support sent you this link and you have read and fully
        understood every point above.
      </Alert>

      <p className="mb-0">
        <strong className="text-danger">
          If you proceed after ignoring instructions or making an error, TurnPoint Support may not be able to assist.
        </strong>
      </p>

    </div>
  );
};

export default Introduction;
